export default __webpack_public_path__ + "b9b8dbb17bd31d2863c949b3dc479029.jpg";